/* istanbul ignore file */
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormControlLabel,
  FormGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import frLocale from 'date-fns/locale/fr';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { Checkbox } from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/TransactionManagerTimeLine/ContactVictim/messages';
import {
  ASSIGN_EXPERT,
  EMPTY_ASSIGN_EXPERT_TRANSACTION,
} from 'containers/data-structure';
import { get, isEmpty, uniqueId } from 'lodash';
import { FormContainer } from 'containers/CourtManagerLegalProceedings/AssignExpert/styled-components';
import moment from 'moment-timezone';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { DATE_FORMAT } from 'constants/global';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { resolveExpertiseType } from 'containers/CourtManagerLegalProceedings/utils';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import useDeepCompareEffect from 'use-deep-compare-effect';
import {
  SECOND_EXAMINATION_TYPE,
  SECOND_EXAMINATION_OPPOSING_LAWYER,
} from 'containers/TransactionManagerTimeLine/ContactVictim/constants';
import {
  getCities,
  getCity,
  getCountriesWithCities,
} from 'containers/RecapManagerPage/utils';
import { OPPOSING_LAWYER_FIELDS } from 'containers/data-structure';
import { SagisConfig } from 'containers/AppContainer/typings';
import { MOROCCO_COUNTRY } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { StyledTitleDrawer } from 'containers/TransactionManagerTimeLine/ContactVictim/style';

export interface MissionFormProps {
  intl: IntlShape;
  assignExpert: {};
  setAssignExpertFields: Function;
  listings: any;
  corporealExperts: any;
  requestGetExpertUsers: Function;
  isUpdate?: boolean;
  generateLetter: boolean;
  setGenerateLetter: Function;
  setOpposingLawyerInfo: Function;
  opposingLawyerInfo: any;
  setSecondExaminationType: Function;
  secondExaminationType: any;
}
const MissionForm: React.FC<MissionFormProps> = (props): JSX.Element => {
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [assignedExperts, setAssignedExperts] = React.useState<string[]>([]);

  const handleChangeSelect = (event: any) => {
    const {
      target: { value },
    } = event;
    const formattedValue = value.filter((el: string) => el);
    setAssignedExperts(
      // On autofill we get a stringified value.
      formattedValue,
    );
    props.setAssignExpertFields({
      ...props.assignExpert,
      assignedExperts: formattedValue.map((element: any) => ({
        expertCode: element,
      })),
    });
  };
  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: SagisConfig) => option?.ItemDescription,
  });
  const countries: SagisConfig[] = getCountriesWithCities(
    get(props.listings, 'country', []),
    get(props.listings, 'villes', []),
  );
  const country =
    countries.find(
      (country: SagisConfig) => country.ItemDescription === MOROCCO_COUNTRY,
    ) || {};
  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.assignExpert, 'assignedExperts', []))) {
      setAssignedExperts(
        get(props.assignExpert, 'assignedExperts').map(
          (element: any) => element.expertCode,
        ),
      );
    }
  }, [props.corporealExperts]);

  const [assignExpertForm, setAssignExpertForm] = React.useState({
    ...EMPTY_ASSIGN_EXPERT_TRANSACTION,
  });
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    if (field === ASSIGN_EXPERT.TYPE) {
      props.requestGetExpertUsers(resolveExpertiseType(event.target.value));
      props.setAssignExpertFields({
        ...props.assignExpert,
        vehicles: [],
        victims: [],
        [field]: event.target.value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        vehicles: [],
        victims: [],
        [field]: event.target.value,
      } as any);
    } else {
      props.setAssignExpertFields({
        ...props.assignExpert,
        [field]: event.target.value,
      });
      setAssignExpertForm({
        ...assignExpertForm,
        [field]: event.target.value,
      });
    }
  };

  const handleDateChange = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const missionDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setAssignExpertFields({
      ...props.assignExpert,
      missionDate: missionDate,
    });
    setAssignExpertForm({
      ...assignExpertForm,
      missionDate: missionDate,
    });
  };

  const handleChangeGenerateLetter = (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const { checked } = event.target;
    props.setGenerateLetter(checked);
  };
  const expert_nature = [
    {
      id: 1,
      title: translate(messages.medicalExpertise, props),
      isVisible: featureService.hasFeature(FEATURES.EXPERT_INTEGRATION),
    },
    {
      id: 2,
      title: translate(messages.accountingExpertise, props),
      isVisible:
        featureService.hasFeature(FEATURES.EXPERT_INTEGRATION_ACCOUNTING) &&
        featureService.hasFeature(FEATURES.TRANSACTION_V2),
    },
  ];
  const handleChangeSecondExaminationType = (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    props.setSecondExaminationType((e.target.value as unknown) as string);
  };
  const handleChangeOpposingLawyerFields = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
    valueField?: any,
  ) => {
    if (field === OPPOSING_LAWYER_FIELDS.CITY) {
      props.setOpposingLawyerInfo({
        ...props.opposingLawyerInfo,
        [field]: get(valueField, 'ItemKey'),
      });
    } else {
      props.setOpposingLawyerInfo({
        ...props.opposingLawyerInfo,
        [field]: event.target.value,
      });
    }
  };

  const allMedicalExperts =
    props.corporealExperts &&
    props.corporealExperts.filter(
      (element: { attributes: { sagis_code: any } }) =>
        !isEmpty(element?.attributes?.sagis_code),
    );

  return (
    <FormContainer>
      <div className="subContainer fee-note-form">
        <div style={StyledTitleDrawer}>
          {translate({ ...messages.ExpertDrawerTitle }, props, {
            number: null,
          })}
        </div>
        <FormControl>
          <InputLabel>{translate(messages.expertNature, props)}</InputLabel>
          <Select
            className="input"
            onChange={handleChange(ASSIGN_EXPERT.TYPE)}
            name={ASSIGN_EXPERT.TYPE}
            value={
              get(props.assignExpert, [ASSIGN_EXPERT.TYPE])
                ? get(props.assignExpert, [ASSIGN_EXPERT.TYPE])
                : null
            }
            disabled={props.isUpdate}
          >
            {expert_nature
              .filter(
                (element: { id: number; title: string; isVisible: boolean }) =>
                  element.isVisible,
              )
              .map(
                (element: {
                  id: number;
                  title: string;
                  isVisible: boolean;
                }) => (
                  <MenuItem value={element.id}>{element.title}</MenuItem>
                ),
              )}
          </Select>
        </FormControl>
        <FormControl className="input">
          <InputLabel ref={inputLabel} id="idd-label-id">
            {translate(messages.expertConseilField, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            name={ASSIGN_EXPERT.ASSIGNED_EXPERT}
            value={assignedExperts}
            renderValue={(assignedExperts: any) =>
              ((assignedExperts as any).map((element: any) =>
                getValueByCode(
                  element as string,
                  get(props.listings, 'intervenants'),
                ),
              ) as any).join(', ') as any
            }
            onChange={handleChangeSelect}
            labelWidth={60}
            multiple
          >
            {!isEmpty(allMedicalExperts) &&
              allMedicalExperts.map(
                (val: {
                  attributes: { sagis_code: [] };
                  firstName: string;
                  lastName: string;
                }) => (
                  <MenuItem
                    key={uniqueId('stackholder_')}
                    value={
                      get(val.attributes.sagis_code, '[0]')
                        ? get(val.attributes.sagis_code, '[0]')
                        : null
                    }
                  >
                    <Checkbox
                      checked={
                        assignedExperts.indexOf(
                          get(val.attributes.sagis_code, '[0]'),
                        ) > -1
                      }
                    />
                    {val.firstName + ' ' + val.lastName}
                  </MenuItem>
                ),
              )}
          </Select>
        </FormControl>

        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            invalidDateMessage=""
            format="dd/MM/yyyy"
            id="lossDate"
            onChange={handleDateChange}
            name={ASSIGN_EXPERT.MISSION_DATE}
            value={dateStringToLocalDate(
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
            )}
            label={translate({ ...messages.ExpertDate }, props)}
            className="input"
            error={
              new Date(
                get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
              ) < new Date(moment().format('YYYY-MM-DD')) ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                '' ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                null ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                'Invalid date'
            }
            helperText={
              new Date(
                get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], ''),
              ) < new Date(moment().format('YYYY-MM-DD')) ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                '' ||
              get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') === null
                ? translate(messages.missionExpertiseDateError, props)
                : get(props.assignExpert, [ASSIGN_EXPERT.MISSION_DATE], '') ===
                  'Invalid date'
                ? translate(messages.invalidDate, props)
                : ''
            }
          />
        </MuiPickersUtilsProvider>
        <FormGroup key={uniqueId()}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                onChange={handleChangeGenerateLetter}
                value={props.generateLetter}
                className="checkbox"
                defaultChecked={props.generateLetter}
              />
            }
            label={translate(messages.generateAssignementLetter, props)}
          />
        </FormGroup>
        <div style={StyledTitleDrawer}>
          {translate(messages.secondExaminationTitle, props)}
        </div>
        <FormControl className="input">
          <InputLabel ref={inputLabel} id="idd-label-id">
            {translate(messages.typeTitle, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            name={'SECOND_EXAMINATION_TYPE'}
            value={props.secondExaminationType}
            onChange={handleChangeSecondExaminationType}
            labelWidth={60}
          >
            {SECOND_EXAMINATION_TYPE.map((element: any) => (
              <MenuItem value={element.title}>{element.title}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {props.secondExaminationType === SECOND_EXAMINATION_OPPOSING_LAWYER && (
          <>
            <Grid item>
              <TextField
                fullWidth
                label={translate(messages.opposingLawyer, props)}
                onChange={handleChangeOpposingLawyerFields(
                  OPPOSING_LAWYER_FIELDS.NAME,
                )}
                data-testid={OPPOSING_LAWYER_FIELDS.NAME}
                name={OPPOSING_LAWYER_FIELDS.NAME}
                value={get(
                  props.opposingLawyerInfo,
                  [OPPOSING_LAWYER_FIELDS.NAME],
                  '',
                )}
                className="input"
              />
            </Grid>
            <Grid item>
              <Autocomplete
                options={getCities(
                  get(props.listings, 'villes', []),
                  get(country, 'ItemKey'),
                )}
                className="input"
                value={getCity(
                  get(props.listings, 'villes', []),
                  String(
                    get(
                      props.opposingLawyerInfo,
                      OPPOSING_LAWYER_FIELDS.CITY,
                      null,
                    ),
                  ),
                )}
                id={OPPOSING_LAWYER_FIELDS.CITY}
                getOptionLabel={(city: SagisConfig) => city.ItemDescription}
                autoSelect={true}
                onChange={
                  handleChangeOpposingLawyerFields(
                    OPPOSING_LAWYER_FIELDS.CITY,
                  ) as any
                }
                filterOptions={filterOptions}
                renderInput={params => (
                  <TextField
                    {...params}
                    name={OPPOSING_LAWYER_FIELDS.CITY}
                    label={translate({ ...messages.opposingLawyerCity }, props)}
                  />
                )}
                fullWidth
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                className="input"
                label={translate(messages.opposingLawyerAddress, props)}
                onChange={handleChangeOpposingLawyerFields(
                  OPPOSING_LAWYER_FIELDS.ADRESS,
                )}
                data-testid={OPPOSING_LAWYER_FIELDS.ADRESS}
                name={OPPOSING_LAWYER_FIELDS.ADRESS}
                value={get(
                  props.opposingLawyerInfo,
                  OPPOSING_LAWYER_FIELDS.ADRESS,
                  '',
                )}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                label={translate(messages.opposingLawyerEmail, props)}
                onChange={handleChangeOpposingLawyerFields(
                  OPPOSING_LAWYER_FIELDS.EMAIL,
                )}
                className="input"
                data-testid={OPPOSING_LAWYER_FIELDS.EMAIL}
                name={OPPOSING_LAWYER_FIELDS.EMAIL}
                value={get(
                  props.opposingLawyerInfo,
                  OPPOSING_LAWYER_FIELDS.EMAIL,
                  '',
                )}
              />
            </Grid>
          </>
        )}
      </div>
    </FormContainer>
  );
};

export default injectIntl(MissionForm);
